<template>
    <section id="management" :class="layout">
        <div class="management__group management__group--1">
            <h2 @click="layout = 'layout-o-c-c'">Templates</h2>
            <div v-if="layout == 'layout-o-c-c'" class="content">
                ASDF
            </div>
        </div>
        <div class="management__group management__group--2">
            <h2 @click="layout = 'layout-c-o-c'">Symbol Groups</h2>
            <div v-if="layout == 'layout-c-o-c'" class="content content--symbol_groups">
                <div class="left--wrapper">
                    <a @click="addSymbolGroup()" class="btn">Add new</a>
                    <div class="symbol__group--scroller">
                        <div class="symbol__group--wrapper">                    
                            <div v-for="group in availableGroups" :key="group" class="symbol__group--entry">
                                <div @click="checkIconHandler" :data-id="group.id" :data-index="index" v-for="(icon, index) in JSON.parse(group.icons)" :key="icon" class="symbol__group--icon" :style="'background-image: url(https://configurator.loxone.com/files/translations/Icons/' + icon + ')'">&nbsp;</div>
                                <template v-if="JSON.parse(group.icons).length < 4">
                                    <div :data-id="group.id" :data-index="JSON.parse(group.icons).length"  class="symbol__group--placeholder">
                                        &nbsp;
                                    </div>
                                </template>
                                <template v-if="JSON.parse(group.icons).length == 0">
                                    <div @click="deleteSymbolGroup(group.id)" class="symbol__group--placeholder symbol__group--delete">
                                        <svg width="32" height="32" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M2.40039 3.69922V15.6992H13.6004V3.69922" stroke="black" stroke-linejoin="round"/>
                                            <path d="M5.19922 2.90039C5.19922 1.79582 6.09465 0.900391 7.19922 0.900391H8.79922C9.90379 0.900391 10.7992 1.79582 10.7992 2.90039V3.30039H5.19922V2.90039Z" stroke="black"/>
                                            <path d="M0.800781 3.30039H15.2008" stroke="black" stroke-linecap="round"/>
                                            <path d="M5.99961 6.90039V12.5004" stroke="black" stroke-linecap="round"/>
                                            <path d="M9.99961 6.90039V12.5004" stroke="black" stroke-linecap="round"/>
                                        </svg>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="icon--wrapper">
                    <div class="box--search">
                        <svg width="14" height="14" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9578 11.2347C8.09499 11.2347 5.7653 8.90543 5.7653 6.04174C5.7653 3.1789 8.09499 0.849634 10.9578 0.849634C13.8207 0.849634 16.1504 3.1789 16.1504 6.04174C16.1504 8.90543 13.8207 11.2347 10.9578 11.2347ZM10.9578 0C7.62599 0 4.91566 2.71033 4.91566 6.04174C4.91566 7.55537 5.47897 8.93687 6.40125 9.99806L0.124578 16.2743C-0.0415258 16.4404 -0.0415258 16.7093 0.124578 16.875C0.207417 16.9583 0.31617 16.9995 0.424923 16.9995C0.533676 16.9995 0.642429 16.9583 0.725268 16.875L7.00194 10.5988C8.06355 11.5215 9.44421 12.0843 10.9578 12.0843C14.2897 12.0843 17 9.37358 17 6.04174C17 2.71033 14.2897 0 10.9578 0Z" fill="black"></path>
                        </svg>
                        <input spellcheck="false" type="text" v-model="iconSearchTerm" placeholder="Search">
                    </div>
                    <div class="symbol__group--scroller">
                        <div class="icon__group--wrapper">                    
                            <div v-for="icon in filteredIcons" v-show="!icon.hidden" :key="icon" class="icon__group--entry" :data-icon="icon.name" :style="'background-image: url(https://configurator.loxone.com/files/translations/Icons/' + icon.name + ')'"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="management__group management__group--3">
            <h2 @click="layout = 'layout-c-c-o'">Functions</h2>
            <div v-if="layout == 'layout-c-c-o'" class="content">
                ASDF
            </div>
        </div>
        <div class="icon__float--wrapper">
            <div v-if="floatingElementVisible" id="floater" :style="'background-image: url(https://configurator.loxone.com/files/translations/Icons/' + floatingElementData.icon + ')'">&nbsp;</div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
export default {
    data() {
        return {
            layout: 'layout-o-c-c',
            icons: {},
            filteredIcons: {},
            availableGroups: {},
            filteredGroupsLeft: {},
            floatingElementVisible: false,
            floatingElementData: {},
            iconSearchTerm: '',
        }
    },
    methods: {
        deleteSymbolGroup(id) {
            var symbolData = new FormData();
            symbolData.append('id', id);

            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                data: symbolData,
                url: 'https://configurator.loxone.com/api/deleteSymbolGroup',
            })
            .then(resp => {
                delete this.availableGroups['symb-'+id];
            });
        },
        addSymbolGroup() {
            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                url: 'https://configurator.loxone.com/api/addSymbolGroup',
            })
            .then(resp => {
                axios({
                    method: 'post',
                    crossDomain: true,
                    withCredentials: true,
                    url: 'https://configurator.loxone.com/api/loadAvailableSymbolGroupsWithKeys',
                })
                .then(resp => {
                    if (resp.data) {
                        this.availableGroups = resp.data;
                        this.filteredGroupsLeft = resp.data;
                    }
                });
            });
        },
        iconFilterLeft() {
                this.filteredIcons = JSON.parse(JSON.stringify(this.icons));
                if(this.iconSearchTerm) {
                    for (const [key, value] of Object.entries(this.filteredIcons)) {
                        this.filteredIcons[key].hidden = false;
                        if(!value.name.includes(this.iconSearchTerm.toLowerCase())) {
                            this.filteredIcons[key].hidden = true;
                        }
                    }
                }

                this.filteredGroupsLeft = JSON.parse(JSON.stringify(this.availableGroups));
            },
        checkIconHandler(e) {
            if(e.altKey) {
                let element_found = false;
                let id = null;
                let index = null;

                    if(e.target.closest(".symbol__group--icon")) {
                        element_found = true;
                        id = e.target.closest(".symbol__group--icon").getAttribute('data-id');
                        index = e.target.closest(".symbol__group--icon").getAttribute('data-index');
                    }
                if(element_found) {
                    
                    let temp_icons = JSON.parse(this.availableGroups['symb-'+id].icons);
                    temp_icons.splice(index, 1);
                    this.availableGroups['symb-'+id].icons = JSON.stringify(temp_icons);
                    this.updateSymbolGroup(this.availableGroups['symb-'+id]);
                }
            }
        },
        updateSymbolGroup(data) {

            var groupData = new FormData();

            groupData.append('data', JSON.stringify(data))

            axios({
                method: 'post',
                crossDomain: true,
                withCredentials: true,
                data: groupData,
                url: 'https://configurator.loxone.com/api/updateSymbolGroup',
            })
            .then(resp => {
            });
        },
        triggerMove(data) {
            this.floatingElementData = data;
            this.floatingElementVisible = true;
        },
    },
    watch: {
        iconSearchTerm: {
            handler() {
                this.iconFilterLeft();
            }
        },
    },
    created() {
        document.addEventListener("mousedown", e => {

            if(e.target.closest(".icon__group--entry")) {
                let content = {
                    icon: e.target.closest(".icon__group--entry").getAttribute('data-icon'),
                };
                this.triggerMove(content);
            }
        });
        document.addEventListener("mousemove", e => {
            if(this.floatingElementVisible) {
                document.getElementById('floater').style.top = ''+(e.clientY - 40)+'px';
                document.getElementById('floater').style.left = ''+(e.clientX - 40)+'px';
            }
        });
        document.addEventListener("mouseup", e => {
            let element_found = false;
            let id = null;
            let index = null;
            
            if(this.floatingElementVisible) {
                if(e.target.closest(".symbol__group--icon")) {
                    element_found = true;
                    id = e.target.closest(".symbol__group--icon").getAttribute('data-id');
                    index = e.target.closest(".symbol__group--icon").getAttribute('data-index');
                }
                if(e.target.closest(".symbol__group--placeholder")) {
                    element_found = true;
                    id = e.target.closest(".symbol__group--placeholder").getAttribute('data-id');
                    index = e.target.closest(".symbol__group--placeholder").getAttribute('data-index');
                }

                if(element_found) {
                    
                    let temp_icons = JSON.parse(this.availableGroups['symb-'+id].icons);


                    temp_icons[index] = this.floatingElementData.icon;

                    this.availableGroups['symb-'+id].icons = JSON.stringify(temp_icons);

                    this.updateSymbolGroup(this.availableGroups['symb-'+id]);
                }

                this.floatingElementVisible = false;
            }
        });
        
        axios({
            method: 'post',
            crossDomain: true,
            withCredentials: true,
            url: 'https://configurator.loxone.com/api/loadAvailableIcons',
        })
        .then(resp => {
            if (resp.data) {
                this.icons = resp.data;
                this.filteredIcons = resp.data;
            }
        });
        axios({
            method: 'post',
            crossDomain: true,
            withCredentials: true,
            url: 'https://configurator.loxone.com/api/loadAvailableSymbolGroupsWithKeys',
        })
        .then(resp => {
            if (resp.data) {
                this.availableGroups = resp.data;
                this.filteredGroupsLeft = resp.data;
            }
        });
    },
    unmounted() {
        document.removeEventListener("mousedown", null);
        document.removeEventListener("mouseup", null);
        document.removeEventListener("mousemove", null);
        window.removeEventListener("resize", null);
    },
}
</script>

<style lang="scss" scoped>
    #floater{
        position: fixed; /* Floating above */
        background-color: #F5F5F5;
        border: 1px solid #E73246;
        width: 58px;
        height: 58px;
        background-size: 34px;
        box-sizing: border-box;
        cursor: pointer;
        background-repeat: no-repeat;
        background-position: center center;
        pointer-events: none;
    }
</style>
<style lang="scss" scoped>
    #management{
        height: 100%;
        display: grid;
        max-width: 1440px;
        margin: 0 auto;
        grid-row-gap: 40px;
        padding: 50px 0;
        box-sizing: border-box;
        color: #000000;

        h2{
            line-height: 50px;
            color: #000000;
            cursor: pointer;
        }

        &.layout-o-c-c{
            grid-template-rows: auto 50px 50px;

            .management__group--2,
            .management__group--3{
                .content{
                    display: none !important;
                }
            }
        }

        &.layout-c-o-c{
            grid-template-rows: 50px auto 50px;

            .management__group--1,
            .management__group--3{
                .content{
                    display: none !important;
                }
            }
        }

        &.layout-c-c-o{
            grid-template-rows: 50px 50px auto;

            .management__group--1,
            .management__group--2{
                .content{
                    display: none !important;
                }
            }
        }

        .management__group{
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
            padding: 0 20px;

            .content{
                height: calc(100% - 50px);
                padding: 0 0 20px 0;
            }
        }
    }
</style>

<style lang="scss" scoped>
    .content--symbol_groups{
        display: grid !important;
        grid-template-columns: 260px auto;
        grid-column-gap: 20px;

        .left--wrapper,
        .icon--wrapper{
            display: grid;
            grid-template-rows: 50px auto;
            
            .symbol__group--scroller{
                overflow-y: auto;
                margin-top: 10px;
                scrollbar-width: auto;
                scrollbar-color: #E6E6E6 #ffffff;
                
                &::-webkit-scrollbar {
                    width: 16px;
                }
                
                &::-webkit-scrollbar-track {
                    background: #ffffff;
                }
                
                &::-webkit-scrollbar-thumb {
                    background-color: #E6E6E6;
                    border-radius: 1px;
                    border: 6px solid #ffffff;
                }

                .box__content--scroll-inner{
                    max-height: 100px;
                }

                .symbol__group--wrapper{
                    display: grid;
                    grid-row-gap: 20px;
                    height: 58px;

                    .symbol__group--entry{
                        user-select: none;
                        background-color: #F5F5F5;
                        border: 1px solid #E6E6E6;
                        width: 100%;
                        height: 58px;
                        background-size: 34px;
                        box-sizing: border-box;
                        cursor: pointer;
                        display: grid;
                        grid-template-columns: repeat(4, 1fr);
                        grid-column-gap: 10px;

                        .symbol__group--icon{
                            background-repeat: no-repeat;
                            background-position: center center;
                            background-size: 32px;
                        }

                        .symbol__group--placeholder{
                            border: 1px solid red;

                            &.symbol__group--delete{
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                border: none;
                            }
                        }
                    }
                }

                .icon__group--wrapper{
                    display: grid;
                    grid-row-gap: 10px;
                    grid-column-gap: 10px;
                    grid-template-columns: repeat(18, 1fr);
                    width: 100%;
                    height: 58px;

                    .icon__group--entry{
                        width: 48px;
                        height: 48px;
                        background-repeat: no-repeat;
                        background-position: center center;
                        background-size: 32px;
                        background-color: #F5F5F5;
                        border: 1px solid #E6E6E6;
                    }

                }
            }

            .box--search{
                border-bottom: 1px solid #CCCCCC;
                padding: 5px 5px;

                svg{
                    margin-right: 15px;
                }

                input{
                    border: none;
                    outline: none;
                    font-size: 16px;
                    line-height: 16px;
                }   
            }
        }
    }
</style>